import * as yup from "yup";

import { EMAIL_REGEX } from "../constants";

export const forgotpasswordSchema = yup.object({
  email:  yup
  .string()
  .email(`Please enter a valid email `)
  .required('Email is required')
  .test('EmailVerification', `Please enter a valid email `, (val) => (EMAIL_REGEX.test(val)), ),
});
